import gql from 'graphql-tag';

/**
 * Data of the block project-measurement-point-operator ("Messstellenbetreiber"): the selected
 * operator with the fields of the select label. Read through
 * `Project.blocks.measurementPointOperator`, which checks the block's read permission.
 */
export const PROJECT_MEASUREMENT_POINT_OPERATOR_FIELDS = gql`
  fragment projectMeasurementPointOperatorFields on ProjectMeasurementPointOperatorBlock {
    id
    number
    measurementPointOperator {
      id
      name
      msbNumber
    }
  }
`;
